import { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

interface DateRangePanelProps {
  /** Main content: an interactive picker or a static date display. */
  children: ReactNode;
  /** Optional subtitle rendered below the main content in muted small text. */
  subtitle?: ReactNode;
}

export function DateRangePanel({ children, subtitle }: DateRangePanelProps) {
  return (
    <div className="flex w-[240px] shrink-0 flex-col items-start gap-2">
      <Typography variant="caption">
        <FormattedMessage
          defaultMessage="Date range"
          description="Caption above a date range display on opening details"
        />
      </Typography>
      {children}
      {subtitle && (
        <Typography variant="small1" className="text-fx-neutral-600">
          {subtitle}
        </Typography>
      )}
    </div>
  );
}

DateRangePanel.Skeleton = function DateRangePanelSkeleton() {
  return (
    <div className="flex w-[240px] shrink-0 flex-col items-start gap-2">
      <div className="bg-fx-neutral-200 h-3 w-20 rounded" />
      <div className="bg-fx-neutral-200 h-5 w-52 rounded" />
      <div className="bg-fx-neutral-200 h-4 w-24 rounded" />
    </div>
  );
};
